import { render, staticRenderFns } from "./CopyTrading.vue?vue&type=template&id=d5f4950e&"
import script from "./CopyTrading.vue?vue&type=script&lang=js&"
export * from "./CopyTrading.vue?vue&type=script&lang=js&"
import style0 from "./CopyTrading.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports